import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { AppState } from '../../../store';
import { withRouter, useHistory } from 'react-router';
import { connect } from 'react-redux';
import { Card, CardActionButton, DynamicForm } from '../../elements';
import { CONSTS } from '../../elements/_constants';
import { postCommodity, getCommodity, putCommodity, fetchCommodities } from '../../../store/commodities/functions';
import { Commodity } from '../../../store/commodities/types';
import Axios from 'axios';
import { BASE_URL } from '../../../inc/constants';
import {useSelector} from 'react-redux';

const NewTransactionComponent = (props) => {
    let history = useHistory();
    const [obj, setObj] = useState();
    const [fields, setFields] = useState([]);
    const [commodities, setCommodities] = useState([]);
    const token = useSelector(state => state.base.token);

    useEffect(() => {
        loadCommodities();
        if (props.isUpdate) {
            loadObj()
        };
        return () => { }
    }, []);

    const loadObj = () => {
        const headers = {Authorization: `token ${token}`};
        var id = props.match.params.id;
        Axios.get(`${BASE_URL}/store/transactions/${id}/`, {headers})
        .then(res => {
            setObj(res.data);
        })
    }
    const loadCommodities = () => {
        const headers = {Authorization: `token ${token}`};
        Axios.get(`${BASE_URL}/commodities/`, {headers})
        .then(res => {
            setCommodities(res.data);
        })
    }

    useEffect(() => {
        setFields([
            {
                id: "commodity_id",
                label: "نام کالا",
                value: obj && obj.commodity_id,
                htmltype: 'select',
                items: commodities.map(comm => ({label: comm.name, value: comm.id})),
                required: true
            },
            {
                id: 'type',
                label: 'نوع',
                htmltype: 'select',
                defaultValue: 2,
                value: obj && (obj.count >= 0 ? 1 : 2),
                items: [
                    {
                        label: 'ورود',
                        value: 1
                    },
                    {
                        label: 'خروج',
                        value: 2
                    }
                ],
                required: true
            },
            {
                id: "count",
                label: "تعداد ورود/خروج",
                htmltype: 'number',
                value: obj && Math.abs(obj.count),
                required: true,
            },
            {
                id: "method",
                htmltype: "text",
                label: "روش اجرا",
                value: obj && obj.method,
                placeholder: 'الایزا، آلفا و ..'
            },
            {
                id: "dosage",
                htmltype: "text",
                label: "مقدار مصرف",
                value: obj && obj.dosage,
                placehodler: 'ویال، قطره و ..'
            },
            {
                id: "description",
                htmltype: "textarea",
                required: false,
                label: "توضیحات",
                value: obj && obj.description,
            },
        ])
    }, [commodities, obj])

    const handleSubmit = (data) => {
        console.log(data);
        if (data['type'] == 2) {
            data['count'] = -1 * Math.abs(data['count']);
        } else {
            data['count'] = Math.abs(data['count']);
        }
        console.log(data);
        const headers = {Authorization: `token ${token}`};
        if (props.isUpdate) {
            var id = props.match.params.id;
            Axios.put(`${BASE_URL}/store/transactions/${id}/`, data, {headers})
            .then(res => {
                history.push(`/store/transactions/${res.data.id}/edit`);
            })
            // props.onUpdateCommodity(props.match.params.id, data, () => {
            //     history.push('/store');
            // });
        } else {
            Axios.post(`${BASE_URL}/store/transactions/`, data, {headers})
            .then(res => {
                history.push(`/store/transactions/${res.data.id}/edit`);
            })
            // props.onCreateCommodity(data, () => {
            //     history.push('/store');
            // });
        }

    }
    return (
        <div className={props.className}>
            <Card
                title="ثبت ورود/خروج کالا"
                headerMeta={<>
                    <CardActionButton title="بازگشت" to={`/store`} hasBorderRight={true} />
                </>}
            >
                <DynamicForm isEdit={props.isUpdate} fields={fields} onSubmit={handleSubmit} />
            </Card>
        </div>
    )
}
const NewTransaction = styled(NewTransactionComponent)`
  @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
    padding-left: 15px;
  }
`;

export default NewTransaction;
